import React from 'react'

import useIsServer from '../../hooks/useIsServer'

import Map from '../../components/maps/Map'
import MarkerCallout from '../../search/Map/MarkerCallout'

type BucketListMapResult = Omit<
  GQL_MapResult,
  'markerCount' | 'coordinates'
> & {
  location: number[]
}

type BaseBucketListMapProps = {
  results: BucketListMapResult[]
  loading: boolean
  filters: GQL_SearchFilters
  searchQuery: string
  mobile?: boolean
}

const BucketListMap = ({
  results,
  loading,
  filters,
  searchQuery,
  mobile,
}: BaseBucketListMapProps) => {
  const isServer = useIsServer()

  if (isServer) {
    return null
  }

  return (
    <Map
      filters={filters}
      results={results}
      loading={loading}
      searchQuery={searchQuery}
      PopupComponent={MarkerCallout}
      mobile={mobile}
      analyticsSource="bucket_list"
      noSearchThisArea
    />
  )
}

export default BucketListMap
